/**
 * useMetaDefinitions
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import MetaDefinitionsContext from './meta-definitions-context'

const useMetaDefinitions = () => {
  const context = useContext(MetaDefinitionsContext)
  return context
}

export default useMetaDefinitions
